module.exports = __webpack_public_path__ + "static/1-30ca6a7a51b400a0fcb5e331e3dc0828.jpg";